<template>
  <Teleport to="body">
    <div class="howto-backdrop" @click.self="close">
      <div class="howto" role="dialog" aria-label="How to play">
        <button class="howto__close" aria-label="Close" @click="close">✕</button>

        <div class="howto__body">
          <h3>{{ slide.title }}</h3>

          <!-- The example chain: a real one from this game's own bot testing.
               "A haunted piano" was drawn, and the next player saw a barcode.
               That IS the game, so it is also the illustration. -->
          <div v-if="slide.chain" class="howto__chain">
            <span class="howto__chip">a haunted piano</span>
            <span class="howto__arrow" aria-hidden="true">→</span>
            <svg class="howto__doodle" viewBox="0 0 100 100" aria-label="A drawing of a piano that looks like a barcode">
              <rect x="12" y="30" width="76" height="42" rx="3" fill="none" stroke="currentColor" stroke-width="3" />
              <path d="M20 30v42M28 30v42M36 30v42M44 30v42M52 30v42M60 30v42M68 30v42M76 30v42" stroke="currentColor" stroke-width="2.5" fill="none" />
              <path d="M24 30v24M40 30v24M56 30v24M72 30v24" stroke="currentColor" stroke-width="5" fill="none" />
              <path d="M30 22 q 8 -14 22 -6" stroke="currentColor" stroke-width="2" fill="none" opacity="0.6" />
            </svg>
            <span class="howto__arrow" aria-hidden="true">→</span>
            <span class="howto__chip">“barcode”</span>
          </div>

          <!-- eslint-disable-next-line vue/no-v-html -- content is this file's own
               constant strings below, never user input -->
          <p v-for="(line, i) in slide.lines" :key="i" class="howto__line" v-html="line" />
        </div>

        <div class="howto__nav">
          <button class="secondary" :disabled="index === 0" @click="index -= 1">Back</button>
          <span class="howto__dots">
            <i
              v-for="(s, i) in slides"
              :key="i"
              class="howto__dot"
              :class="{ 'howto__dot--on': i === index }"
            />
          </span>
          <button v-if="index < slides.length - 1" class="primary howto__next" @click="index += 1">
            Next
          </button>
          <button v-else class="primary howto__next" @click="close">
            Got it
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
// The walkthrough. Matt: friends he invites have often never played, and they
// should be able to "get a sense of the lay of the land when they first
// arrive" without waiting for him to teach it. Same pattern as incan-gold and
// no-thanks; this game has no card art, so the illustration is a chain -
// a real one, from the first all-bot game this app ever ran.
const SLIDES = [
  {
    title: 'Drawing telephone',
    chain: true,
    lines: [
      'Everyone starts a book by writing <strong>any word or phrase they like</strong>. Stuck? There\'s a suggestion button.',
      'Books pass around the table. Each player <strong>draws</strong> the phrase they\'re handed, or <strong>guesses</strong> what the drawing they\'re handed was meant to be.',
      'The phrase decays as it travels. That\'s not a problem — that\'s the game.',
    ],
  },
  {
    title: 'Your turn, every turn',
    lines: [
      'You always have exactly one page in front of you.',
      'Handed a <strong>phrase</strong>? Draw it. No words or letters in the drawing — that\'s the one rule.',
      'Handed a <strong>drawing</strong>? Write your best guess at what it is. Commit! A confident wrong answer beats a careful hedge.',
      'When everyone has finished their page, all the books pass at once.',
    ],
  },
  {
    title: 'No score, just the reveal',
    lines: [
      'Every book fills <strong>twelve pages</strong>, so with a small group a book laps the table — you may even get your own back. By then, you won\'t recognise it.',
      'When the pages run out, the books are read back <strong>one at a time, together</strong> — phrase, drawing, guess, drawing… whoever\'s book it is turns the pages.',
      'There\'s no scoring. The reveal is the whole point.',
      'Short of players? <strong>Robots</strong> can fill seats — they draw and guess for themselves, badly, which is exactly what you want.',
    ],
  },
];

export default {
  name: 'HowToPlay',
  emits: ['close'],
  data() {
    return { index: 0, slides: SLIDES };
  },
  computed: {
    slide() { return this.slides[this.index]; },
  },
  methods: {
    close() { this.$emit('close'); },
  },
};
</script>
